
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.25 11.313c.146-.23.26-.48.344-.75a2.87 2.87 0 00.125-.844c0-.563-.136-1.063-.406-1.5a3.057 3.057 0 00-1.094-1.094 2.791 2.791 0 00-1.5-.406c-.563 0-1.073.135-1.531.406-.438.27-.792.635-1.063 1.094a2.79 2.79 0 00-.406 1.5c0 .562.135 1.073.406 1.531.27.438.625.792 1.063 1.063.458.27.968.406 1.53.406.292 0 .574-.042.845-.125.27-.084.52-.198.75-.344l2.062 2.094.969-.969-2.094-2.063zm-2.531.062c-.459 0-.854-.156-1.188-.469a1.677 1.677 0 01-.469-1.187c0-.459.157-.844.47-1.156.333-.334.728-.5 1.187-.5.458 0 .844.166 1.156.5.333.312.5.697.5 1.156 0 .458-.167.854-.5 1.187a1.57 1.57 0 01-1.156.469zm-.25-5.656a3.89 3.89 0 00-1.375.312l-.375-.562-2.531 4.125-2-2.344-2.438 3.875-1.094-.781L4 5l2 2.344L8.656 3l.188.281c.125.188.27.417.437.688l.563.812c.187.25.333.469.437.657l.188.28zm1.75.343a4.447 4.447 0 00-1.375-.343l.25-.375c.166-.271.375-.604.625-1 .27-.417.541-.854.812-1.313.292-.458.563-.885.813-1.281.27-.417.49-.75.656-1l.25-.406 1.094.781-3.125 4.938z","fill":"#172542"}})])
          )
        }
      }
    